import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import {
  AUTH_PREFIX_PATH,
  UNAUTHENTICATED_ENTRY,
  REDIRECT_URL_KEY,
} from 'configs/AppConfig';

import { fetchMe } from 'store/slices/authSlice';
import Loading from 'components/shared-components/Loading';

const PUBLIC_NO_AUTH_ROUTES = ['/chat-widget'];

const ProtectedRoute = () => {
  const dispatch = useDispatch();

  const { token, user, userLoading } = useSelector((state) => state.auth);
  const location = useLocation();

  const isPublicNoAuthRoute = PUBLIC_NO_AUTH_ROUTES.some((path) =>
    location.pathname.startsWith(path)
  );

  useEffect(() => {
    if (!isPublicNoAuthRoute && token && !user && !userLoading) {
      dispatch(fetchMe());
    }
  }, [token, user, userLoading, dispatch, isPublicNoAuthRoute]);

  if (isPublicNoAuthRoute) {
    return <Outlet />;
  }

  if (!token) {
    return (
      <Navigate
        to={`${AUTH_PREFIX_PATH}${UNAUTHENTICATED_ENTRY}?${REDIRECT_URL_KEY}=${location.pathname}`}
        replace
      />
    );
  }

  if (token && !user) {
    return <Loading cover="content" />;
  }

  return <Outlet />;
};

export default ProtectedRoute;